<template>
  <div id="appMain" class="container">
    <div v-for="(topic, topicIndex) in contents" v-bind:key="topicIndex">
      <div class="title"> {{topic.title}} </div>
      <div :class="content.type" v-for="(content, contentIndex) in topic.content" v-bind:key="contentIndex">
        {{content.text}}
      </div>
    </div> 
    <hr/>
  </div>
</template>
<script>
import {baseURL} from './IPconfig.js'
import json from '@/components/json/content.json'
export const localIP = baseURL.ip2 + '/static/json/content.json'
export default {
  name: 'detailView',
  data () {
    return {
      contents: json.topics
    }
  },
  methods: {
  }
}
</script>
<style scoped>
#appMain {
		font-size: 62.5%;
		font-family: Tahoma, "Lucida Grande", Arial, Helvetica, sans-serif;
		color: #102536;
		min-width: 100em;
		max-width: 760px;
		margin: auto;
	}
	.title {
		font-size: 2.4em;
		color: #14556b;
		margin-top: 1em;
	}
	.h2 {
		font-size: 1.5em;
		margin-bottom: 5px;
	}
	.h3 {
		font-size: 1em;
		color: #993;
		margin-bottom: 5px;
	}
	.p {
	 font-size: 1.2em;
	 line-height: 150%;
	 text-indent: 2em;
	 margin-top: 0;
	 margin-bottom: 5px;
	}
	.code {
	 font-size: 1.2em;
   color:blanchedalmond;
   background-color: #14556b;
	 line-height: 150%;
	 text-indent: 2em;
	 margin-top: 0;
	 margin-bottom: 5px;
	}
  .byline {
  color: #73afb7;
  font-size: 1.5em;
  margin-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
  font-variant: small-caps;
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DetailView.vue